import { BiLibrary } from "react-icons/bi";
import { FaRobot } from "react-icons/fa";
import {
  MdAssignment,
  MdFeedback,
  MdGroup,
  MdMessage,
  MdNote,
  MdStore,
  MdSubscriptions,
  MdVpnKey,
  MdWorkspaces,
} from "react-icons/md";
import { GrIntegration } from "react-icons/gr";

// Base routes structure - names will be translated in components using these routes
const routes: RoutesType[] = [
  {
    name: "Chat",
    nameKey: "routes.chat",
    layout: "",
    path: "/chat",
    icon: <MdMessage className="text-inherit h-5 w-5" />,
    collapse: false,
  },
  {
    name: "Agents",
    nameKey: "routes.agents",
    layout: "/dashboard",
    path: "/agents",
    icon: <FaRobot className="text-inherit h-5 w-5" />,
    collapse: false,
  },
  {
    name: "Create Agent",
    nameKey: "routes.createAgent",
    layout: "/dashboard/agents",
    path: "/create",
    icon: <FaRobot className="text-inherit h-5 w-5" />,
    hidden: true,
    collapse: false,
  },

  {
    name: "Library",
    nameKey: "routes.library",
    layout: "/dashboard",
    path: "/library",
    icon: <BiLibrary className="text-inherit h-5 w-5" />,
    collapse: false,
  },

  {
    name: "Roles",
    nameKey: "routes.roles",
    layout: "/dashboard",
    path: "/roles",
    icon: <MdWorkspaces className="text-inherit h-5 w-5" />,
    collapse: false,
  },
  {
    name: "Users",
    nameKey: "routes.users",
    layout: "/dashboard",
    path: "/users",
    icon: <MdGroup className="text-inherit h-5 w-5" />,
    collapse: false,
  },
  {
    name: "Feedbacks",
    nameKey: "routes.feedbacks",
    layout: "/dashboard",
    path: "/feedback",
    icon: <MdFeedback className="text-inherit h-5 w-5" />,
    collapse: false,
  },
  {
    name: "Technical Notes",
    nameKey: "routes.technicalNotes",
    layout: "/dashboard",
    path: "/technical-notes",
    icon: <MdNote className="text-inherit h-5 w-5" />,
    collapse: false,
  },
  {
    name: "Subscription Plans",
    nameKey: "routes.subscriptionPlans",
    layout: "/dashboard",
    path: "/subscription-plans",
    icon: <MdAssignment className="text-inherit h-5 w-5" />,
    collapse: false,
  },
  {
    name: "Subscriptions",
    nameKey: "routes.subscriptions",
    layout: "/dashboard",
    path: "/subscriptions",
    icon: <MdSubscriptions className="text-inherit h-5 w-5" />,
    collapse: false,
  },
  {
    name: "API Keys",
    nameKey: "routes.apiKeys",
    layout: "/dashboard",
    path: "/api-keys",
    icon: <MdVpnKey className="text-inherit h-5 w-5" />,
    collapse: false,
  },
  {
    name: "Workspaces",
    nameKey: "routes.workspaces",
    layout: "/dashboard",
    hidden: true,
    path: "/workspaces",
    icon: <MdGroup className="text-inherit h-5 w-5" />,
    collapse: false,
  },
  {
    name: "Profile",
    nameKey: "routes.profile",
    layout: "/dashboard",
    hidden: true,
    path: "/profile",
    icon: <MdGroup className="text-inherit h-5 w-5" />,
    collapse: false,
  },
  {
    name: "Workspace settings",
    nameKey: "routes.workspaceSettings",
    layout: "/dashboard",
    hidden: true,
    path: "/cworkspace",
    icon: <MdGroup className="text-inherit h-5 w-5" />,
    collapse: false,
  },
  {
    name: "Organisation settings",
    nameKey: "routes.organisationSettings",
    layout: "/dashboard",
    hidden: true,
    path: "/corganization",
    icon: <MdGroup className="text-inherit h-5 w-5" />,
    collapse: false,
  },
  {
    name: "Integrations",
    nameKey: "routes.integrations",
    layout: "/dashboard",
    path: "/integrations",
    icon: <GrIntegration className="text-inherit h-5 w-5" />,
    collapse: false,
  },
  {
    name: "Marketplace",
    nameKey: "routes.marketplace",
    layout: "/dashboard",
    path: "/marketplace",
    icon: <MdStore className="text-inherit h-5 w-5" />,
  },
];
export default routes;
